import EventBus from "../components/event-bus";
import {HTTP} from '../http-common';
import moment from 'moment';

export const commonMixins = {

    data: () => ({
            colors: ['#ffbb44', '#098de1', '#154174', '#c3202b', '#607d8b', '#444444', '#446626', '#cc9636', '#23727b'],
            menuData: [
                {

                }
            ],
            features: [
                {

                }
            ],
            menuslug: "",
            pageType: [],
            currentTab: "",
            menuParentSlug: "",
            systemYear: "2019",
            isPageLoading: true,
            hasMenuViewPermission: false,
            hasMenuEditPermission: false
        }),
    mounted: function () {

        var self = this;

        //check token if user came from rental
        var token = this.$route.query.token;
        if (token != undefined) {
            localStorage.setItem("tkn", token);
        }

        /* if Acces Token is not exits redirect to login page. */
        if (localStorage.getItem("tkn") == "" || localStorage.getItem("tkn") == null) {
            let current_build = window.localStorage.getItem("build_version");
            localStorage.clear();
            localStorage.setItem("build_version", current_build);
            // self.$router.push("/");
        }
        //$("html, body").animate({scrollTop: 0}, 10);
    },
    created() {
        /*console.log("mixin created");*/
    },
    beforeMount() {

    },
    watch: {
        menuslug: function (menuslug) {
            var self = this;
            setTimeout(function () {
                self.menuActive(menuslug);
            }, 1000);
            //self.$store.dispatch('getRole');
        }
    },

    methods: {
        getMenuDetails: function (slug) {
            var self = this;
            var config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tkn")
                },
                params: {
                    'slug': slug,
                }
            };
            self.showLoader();
            self.isPageLoading = true;
            HTTP.get("get_menu_details", config)
                    .then(function (response) {
                        self.hasMenuViewPermission = self.hasMenuEditPermission = false;

                        if (response.data.code == 200) {
                            self.currentTab = "";
                            self.menuData = response.data.content.menu_details;

                            if(response.data.content.menu_details && response.data.content.menu_details.is_view_allow == 1) {
                                self.hasMenuViewPermission = true;
                            }
                            if(response.data.content.menu_details && response.data.content.menu_details.is_edit_allow == 1) {
                                self.hasMenuEditPermission = true;
                            }
                            self.menuslug = self.menuData.slug;
                            self.menuParentSlug = (self.menuData.parent_slug != null) ? self.menuData.parent_slug : self.menuData.slug;
                            self.pageType = [];
                            if (typeof self.menuData.page_type === "string" && self.menuData.page_type.indexOf(',') > -1) {
                                self.pageType = self.menuData.page_type.split(',').sort();
                            } else {
                                self.pageType.push(self.menuData.page_type);
                            }
                            if (self.menuData.features.length) {
                                $.each(self.menuData.features, function (i) {
                                    if(self.pastTab == self.removeSpacesString(self.menuData.features[i].name)){
                                        self.currentTab = self.pastTab; 
                                    }
                                    if (self.currentTab == "") {
                                        self.currentTab = self.removeSpacesString(self.menuData.features[i].name);
                                        /*if (response.data.content.features[i].id == 1) {
                                         self.currentTab = "discussion";
                                         } else if (response.data.content.features[i].id == 2) {
                                         self.currentTab = "attachment";
                                         } else if (response.data.content.features[i].id == 3) {
                                         self.currentTab = "attachment";
                                         }*/
                                    }
                                });
                            } else {
                                self.currentTab = self.removeSpacesString("Attachments");
                            }
                            self.changeTab(self.currentTab);
                            // Getting User Roles with Menu Details
                            self.$store.commit('changeUserRole', response.data.content.roles.id);
                            localStorage.setItem("user_role", response.data.content.roles.id);
                            self.systemYear = response.data.content.system_year;
                            localStorage.setItem("systemYear", response.data.content.system_year);
                            EventBus.$emit("systemYear", true, response.data.content.system_year);
                            if($(window).width() < 1100){
                                $(".app-sidebar-right").removeClass("toggled");
                                $(".app-sidebar-right").removeClass("toggled-2");
                            }
                            /* Build version checking start*/
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = response.data.content.build;
                            console.log('current_build ' + current_build);
                            console.log('latest_build ' + latest_build);
                            if(current_build == null || current_build == 'null') {
                                console.log("Set in 1st If...");
                                localStorage.setItem("build_version", response.data.content.build);
                            } else if (current_build != undefined && current_build == '') {
                                console.log("Set in 2nd If...");
                                localStorage.setItem("build_version", response.data.content.build);
                            } else if(current_build != latest_build){
                                console.log("reload...");
                                localStorage.setItem("build_version", response.data.content.build);
                                location.reload(true);
                            } else {
                                console.log("Else...");
                            }
                            /* Build version checking end*/
                        }

                        self.hideLoader();
                        self.isPageLoading = false;
                    }).catch(function (err) {
                        self.hideLoader();
                        self.isPageLoading = false;
                        console.log(err);
                        self.catchHandler(err, function () {});
            });
            self.menuActive(slug);
        },
        getFeatures: function () {

            var self = this;
            var config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tkn")
                },
            };
            HTTP.get("get_features", config)
                .then(function (response) {
                    if (response.data.code == 200) {
                        self.features = response.data.content;
                    }
                })
                .catch(function (err) {
                    self.catchHandler(err, function () {});
                });
        },
        /* Get User Role Permission */
        /*
         getRole: function () {
         var self = this;
         var config = {
         headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
         };
         HTTP.get("user/role", config)
         .then(function (response) {
         if (response.data.status == 'success') {
         localStorage.setItem("user_role", response.data.content.roles.id);
         self.systemYear = response.data.content.system_year;
         return response.data.content.roles.id;
         }
         })
         .catch(function (err) {
         if (err.response.status == 0) {
         self.error = "Remote server can not be reachable";
         } else {
         //redirect to login page if user not authenticated
         if (err.response.status == 401) {
         localStorage.removeItem('user_obj');
         localStorage.removeItem('api_token');
         //self.$router.push("/login");
         self.$router.push("/");
         }
         }
         });
         },
         */
        //make sentence first letter capital
        ucString: function (data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        menuActive: function (slug) {
            /* console.log(slug); */
        //setTimeout(function () {
            $(".menuCommon").removeClass("active");
            $("." + slug).addClass("active");
            $("." + slug).parent().show();
            $('#menu ul').children('.current').parent().show();
            //#menu li a,
            $('#menu li .menu-arrow').click(
                function() {
                    // var checkElement = $(this).next();
                    var checkElement = $(this).parents('.menuCommon').children('ul.tree');
                    if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                        return false;
                    }
                    if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                        $('#menu ul:visible').slideUp('normal');
                        checkElement.slideDown('normal');
                        return false;
                    }
                }
            );
             /*$('#menu li .menu-arrow').click(
                function() {
                    var checkElement = $(this).next();
                    if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                        return false;
                    }
                    if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                        $('#menu ul:visible').slideUp('normal');
                        checkElement.slideDown('normal');
                        return false;
                    }
                }
            );*/

        //}, 1000);
        },
        changeTab: function (tab) {
            var self = this;
            self.currentTab = tab;
            if (tab == "discussion") {
                $(".btnDiscussion").removeClass("btn-outline-primary");
                $(".btnDiscussion").addClass("btn-primary");
                $(".btnAttachment").removeClass("btn-primary");
                $(".btnAttachment").addClass("btn-outline-primary");
                $(".btnIframeURL").removeClass("btn-primary");
                $(".btnIframeURL").addClass("btn-outline-primary");
            } else if (tab == "iframeurl") {
                $(".btnIframeURL").removeClass("btn-outline-primary");
                $(".btnIframeURL").addClass("btn-primary");
                $(".btnDiscussion").removeClass("btn-primary");
                $(".btnDiscussion").addClass("btn-outline-primary");
                $(".btnAttachment").removeClass("btn-primary");
                $(".btnAttachment").addClass("btn-outline-primary");
            } else {
                $(".btnAttachment").removeClass("btn-outline-primary");
                $(".btnAttachment").addClass("btn-primary");
                $(".btnDiscussion").removeClass("btn-primary");
                $(".btnDiscussion").addClass("btn-outline-primary");
                $(".btnIframeURL").removeClass("btn-primary");
                $(".btnIframeURL").addClass("btn-outline-primary");
            }
        },
        utcToLocal: function (dateTime, format) {
            var self = this;
            var local = moment.utc(dateTime).local().format(format);
            return local;
        },
        formatDateTime: function (dateTime, format) {
            var self = this;
            var dateTime = new Date(dateTime);
            var dateTime = moment(dateTime).format(format);
            return dateTime;
        },
        gerRandomColor: function () {
            var self = this;
            var item = self.colors[Math.floor(Math.random() * self.colors.length)];
            return item;
        },
        showSAlert: function (message, type, callback) {
            this.$swal.fire(
                    message,
                    '',
                    type
                    );
            //callback("message");
        },
        catchHandler: function (err, callback) {
            var self = this;
            switch (err.response.status) {
                case 0:
                    this.showSAlert('Remote server can not be reachable', 'error', callback);
                case 400:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 401:
                    let current_build = window.localStorage.getItem("build_version");
                    localStorage.clear();
                    localStorage.setItem("build_version", current_build);
                    // window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/login?redirect=" + process.env.VUE_APP_FRONT_ROOT_URL + '&slug=' + process.env.VUE_APP_PROJECT_SLUG;
                    window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/logout?redirect_url=" + process.env.VUE_APP_FRONT_ROOT_URL + '&slug=' + process.env.VUE_APP_PROJECT_SLUG;
                    break;
                case 404:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 409:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
            }
        },
        removeSpacesString: function (srting) {
            return srting.replace(/\s/g, '').toLowerCase();
        },
        stringTrim: function (string, length) {
            length = (typeof length !== 'undefined') ? length : 20;
            var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
            return string1;
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
                $(".loading-container").hide();
            //}, 1700);
        },
        firstLoadMenu: function () {
            var self = this;
            $('#menu ul').hide();
        },
        enableDisableButton: function (identifire,is_disable,is_id) {
            if(is_id == true){
                $('#'+identifire).attr("disable", is_disable);
            } else {
                $('.'+identifire).attr("disable", is_disable);
            }
        },
        getRecords: function (serverPage, perPage, totalRecords) {
            serverPage = Number(serverPage);
            perPage = Number(perPage);
            totalRecords = Number(totalRecords);
            var firstLoad = true;
            var firstRecord = 0;
            var lastRecord = 0;

            var page = serverPage;
            for (var i = 1; i <= page; i++) {
                if (firstLoad == true) {
                    firstRecord = lastRecord + 1;
                    lastRecord = perPage;
                    firstLoad = false;
                } else {
                    firstRecord = lastRecord + 1;
                    lastRecord = (perPage * i);
                }
            }

            if (totalRecords != 0) {
                if (lastRecord > totalRecords) {
                    lastRecord = totalRecords;
                }
            } else if (totalRecords == 0) {
                firstRecord = 0;
                lastRecord = 0;
            }
            return firstRecord + " - " + lastRecord;
        },
        /* Store and apply filters for different lists End */
        downloadFile: function (href) {
            var fileNameIndex = href.lastIndexOf("/") + 1;
            var filename = href.substr(fileNameIndex);
            if ($('#DynDownloadAnchor').length) {
                $('#DynDownloadAnchor').remove();
            }
            var anchor = document.createElement('a');
            anchor.id = "DynDownloadAnchor";
            anchor.style.display = "none";
            anchor.href = href;
            // anchor.target = "_blank";
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
        },
        getAllPermissions: function () {
            var self = this;
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
            };
            HTTP.get('get-all-permissions', config)
                .then(response => {
                    EventBus.$emit('all-permissions', false, response.data.content);
                })
                .catch(function (err) {
                    console.log(err);
                    self.catchHandler(err, function () {});
                });
        },
        getUserPermissions: function () {
            var self = this;
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
            }
            var fields = {
                user_id: userJson['id'],
            };
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
            };
            HTTP.post('get-login-id-permissions', fields, config)
                .then(response => {
                    /* var objData = {};
                    objData['id'] = 0;
                    objData['name'] = "dashboard";
                    response.data.content.user.permissions =  response.data.content.user.permissions.concat(objData);
                    EventBus.$emit('role', false, response.data.content.user.roles[0].id, response.data.content.user.roles[0].name); */
                    EventBus.$emit('permissions', false, response.data.content.user.permissions);
                })
                .catch(function (err) {
                    console.log(err);
                    self.catchHandler(err, function () {});
                });
        },
        validEmail : function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        addNewLineInEmailColumn: function(invoice) {
            if(invoice != null && invoice != "") {
                let strInvoice = invoice.replaceAll(",", "<br/>");
                return strInvoice;
            } else {
                return "";
            }
        },
        storeFilters: function (listType, pageFilters, clear) {
            if (typeof clear === 'undefined' || clear === null) {
                clear = false;
            }
            var getfilters = {};
            if (!clear) {
                var filterObj = localStorage.getItem("filters");
                if (filterObj != null) {
                    getfilters = JSON.parse(filterObj);
                }
            }
            getfilters[listType] = pageFilters;
            window.localStorage.setItem("filters", JSON.stringify(getfilters));
        },
        loadFilters: function (listType, columns, serverParams, listClass) {
            if (typeof listClass === 'undefined' || listClass === null) {
                listClass = '';
            }
            var appliedFilters = localStorage.getItem('filters');
            if (appliedFilters != null) {
                appliedFilters = JSON.parse(appliedFilters);
                if (appliedFilters[listType] != null) {
                    serverParams.sort = appliedFilters[listType].sort;
                    /* console.log(appliedFilters[listType].sort['type']);
                    var goodTableArr = $('.par-request-good-table-container th.vgt-left-align');
                    if(goodTableArr) {
                        console.log(goodTableArr[0].innerText);
                        $.each(goodTableArr, function (i) {
                            // goodTableArr[i].className = 'vgt-left-align sortable sorting sorting-desc';
                            // if(appliedFilters[listType].sort['type'] == 'asc') {
                            //     goodTableArr[i].className = 'vgt-left-align sortable sorting sorting-asc';
                            // }
                        });
                    } */
                    serverParams.page = appliedFilters[listType].page;
                    serverParams.perPage = appliedFilters[listType].perPage;
                    serverParams.setCurrentPage = appliedFilters[listType].setCurrentPage;
                    serverParams.columnFilters = appliedFilters[listType].columnFilters;
                    $.map(appliedFilters[listType].columnFilters, function (val, key) {
                        $.each(columns, function (i) {
                            if (columns[i].field == key && val != '') {
                                let el = $('.' + listClass + ' *[placeholder="' + columns[i].filterOptions.placeholder + '"]');
                                el.val(val);
                                columns[i].filterOptions.filterValue = val;
                            }
                        });
                    });
                }
            }
        },
        loadAllFilter: function(listType, listClass) {
            if (typeof listClass === 'undefined' || listClass === null) {
                listClass = '';
            }
            var appliedFilters = localStorage.getItem('filters');
            if (appliedFilters != null) {
                appliedFilters = JSON.parse(appliedFilters);
                if (appliedFilters[listType] != null) {
                    return appliedFilters[listType];
                }
            }
            return [];
        },
        /* Store and apply archive for different lists Start */
        /**
         * Store archive in user's browser local storage of the pages by using this function. 
         * @param {string} listType List identifier for stored archive for the specific filter
         * @param {object} pageArchive object of the page archive for the pag which is identified by identifier
         * @param {boolean} clear Need to clear archive of other pages.
         */
        storeArchive: function (listType, pageArchive, clear) {
            if (typeof clear === 'undefined' || clear === null) {
                clear = false;
            }
            var getArchiveList = {};
            if (!clear) {
                var archiveObj = localStorage.getItem("is_archived");
                if (archiveObj != null) {
                    getArchiveList = JSON.parse(archiveObj);
                }
            }
            getArchiveList[listType] = pageArchive;
            window.localStorage.setItem("is_archived", JSON.stringify(getArchiveList));
        },
        /**
         * It will load archive list from stored archive data to the list identifier.
         * @param {string} listType List identifier for load archive fot the specific list
         * @param {object} dataObj self object of the list page which is linked with list identifier.
         */
        loadArchive: function (listType, dataObj) {
            var appliedArchives = localStorage.getItem('is_archived');
            if (appliedArchives != null) {
                appliedArchives = JSON.parse(appliedArchives);
                if (appliedArchives[listType] != null) {
                    dataObj.is_archived = appliedArchives[listType];
                    return appliedArchives[listType];
                } else {
                    return 0;
                }
            }
        },
        /* Store and apply archive for different lists Start */

        /* Store and apply category for different lists Start */
        /**
         * Store category in user's browser local storage of the pages by using this function. 
         * @param {string} listType List identifier for stored category for the specific filter
         * @param {object} pageCategory object of the page category for the pag which is identified by identifier
         * @param {boolean} clear Need to clear category of other pages.
         */
        storeCategory: function (listType, categoryName, pageCategory, clear) {
            if (typeof clear === 'undefined' || clear === null) {
                clear = false;
            }
            var getCategoryList = {};
            if (!clear) {
                var categoryObj = localStorage.getItem(categoryName);
                if (categoryObj != null) {
                    getCategoryList = JSON.parse(categoryObj);
                }
            }
            getCategoryList[listType] = pageCategory;
            window.localStorage.setItem(categoryName, JSON.stringify(getCategoryList));
        },
        /**
         * It will load category list from stored category data to the list identifier.
         * @param {string} listType List identifier for load category fot the specific list
         * @param {object} dataObj self object of the list page which is linked with list identifier.
         */
        loadCategory: function (listType, categoryName, dataObj) {
            var appliedCategories = localStorage.getItem(categoryName);
            if (appliedCategories != null) {
                appliedCategories = JSON.parse(appliedCategories);
                if (appliedCategories[listType] != null) {
                    dataObj.categoryName = appliedCategories[listType];
                    return appliedCategories[listType];
                } else {
                    return 0;
                }
            }
        },
        addNewLineInColumn: function(column) {
            if(column != null && column != "") {
                let strColumn = column.replaceAll(",", "<br/>");
                return strColumn;
            } else {
                return "";
            }
        },
        urlValidation: function(url) {
            if(url != '' && url != null){
                var res = url.match(/^(http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
                if(res == null) {
                    return false;
                } else {
                    return true;
                }
            }
            return false;
        },
        copyAttachmentSrc: function(src, id) {
            // Copy src to clipboard
            navigator.clipboard.writeText(src)
                .then(() => {
                    $('#qr-link-copy-tooltip' + id).html('<span style="background-color:#000; color:white;padding: 4px 5px 6px;border-radius: 5px;">Copied!</span>');
                    
                    setTimeout(() => {
                        $('#qr-link-copy-tooltip' + id).text('');
                    }, 2000); // Hide tooltip after 2 seconds
                })
                .catch(err => {
                    $('#qr-link-copy-tooltip' + id).html('<span style="background-color:#000; color:white;padding: 4px 5px 6px;border-radius: 5px;">Failed to copy!</span>');
                    
                    setTimeout(() => {
                        $('#qr-link-copy-tooltip' + id).text('');
                    }, 2000); // Hide tooltip after 2 seconds
                });
        },
        getFirstMenuSlug: function(slug) {
            let firstUrl = '';
            let user_role = localStorage.getItem('user_role');
            if(slug){
                firstUrl = "/" + slug;
            } else {
                if(user_role == 1 || user_role == 2) {  
                    firstUrl = "/uniform/request/list";
                } else {
                    firstUrl = "/uniform/request/add";
                }
            } 
            return firstUrl;
        },
        navigateToFirstMenu: function() {
            var self = this;
            var loginUserId = 1;
            var userObj = localStorage.getItem('user_obj');
            if (userObj) {
                loginUserId = JSON.parse(userObj).id;
            }
            
            HTTP.get("get_first_menu/"+loginUserId, [])
                    .then(function (response) {
                        let responseSlugData = '';
                        if (response.data.code == 200) {
                            responseSlugData = response.data.content;
                        }
                        window.location.href = self.getFirstMenuSlug(responseSlugData);
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });   
        },
        updateUserProfile: function() {
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit('logged-in', true, userJson.first_name, userJson.last_name, userJson.username, userJson.username);
            }
        },
        getSignedUrlPath(file){
            if(file && typeof file !== 'undefined') {
                let config = {
                    headers: { 
                        Authorization: "Bearer " + localStorage.getItem("tkn") 
                    },
                    params: {
                        file: file,
                    }
                };
                HTTP.get("getsignedurlpath", config)
                    .then(function (response) {
                        window.open(response.data.file_path);
                    })
                    .catch(function (err) {
                    });
            }
        },
        setVideoFilePath: function (url) {
            var self = this;
            var video = document.getElementById('video-container');
            video.src = url;
            self.$refs['videoPlayModal'].show();
            video.play();
        },
        closeModalEvent: function (e) {
            var video = document.getElementById('video-container');
            video.pause();
        }
    },
    computed: {
        user_role: {
            get: function () {
                return this.$store.getters.roles;
            },
            set: function (value) {
                this.$store.commit('changeUserRole', value);
            }
        },
        pastTab: {
            get: function () {
                return this.$store.getters.past_tab;
            },
            set: function (value) {
                this.$store.commit('changePastTab', value);
            }
        },
    }
};